'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var hamtSharding = require('hamt-sharding');

var dagPb = require('@ipld/dag-pb');

var murmur3 = require('@multiformats/murmur3');

var hashFn = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(buf) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return murmur3.murmur3128.encode(buf);

          case 2:
            return _context.abrupt("return", _context.sent.slice(0, 8).reverse());

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function hashFn(_x) {
    return _ref.apply(this, arguments);
  };
}();

var addLinksToHamtBucket = function addLinksToHamtBucket(links, bucket, rootBucket) {
  return Promise.all(links.map(function (link) {
    if (link.Name == null) {
      throw new Error('Unexpected Link without a Name');
    }

    if (link.Name.length === 2) {
      var pos = parseInt(link.Name, 16);
      return bucket._putObjectAt(pos, new hamtSharding.Bucket({
        hash: rootBucket._options.hash,
        bits: rootBucket._options.bits
      }, bucket, pos));
    }

    return rootBucket.put(link.Name.substring(2), true);
  }));
};

var toPrefix = function toPrefix(position) {
  return position.toString(16).toUpperCase().padStart(2, '0').substring(0, 2);
};

var toBucketPath = function toBucketPath(position) {
  var bucket = position.bucket;
  var path = [];

  while (bucket._parent) {
    path.push(bucket);
    bucket = bucket._parent;
  }

  path.push(bucket);
  return path.reverse();
};

var findShardCid = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(node, name, blockstore, context, options) {
    var rootBucket, position, prefix, bucketPath, link, block;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!context) {
              rootBucket = hamtSharding.createHAMT({
                hashFn: hashFn
              });
              context = {
                rootBucket: rootBucket,
                hamtDepth: 1,
                lastBucket: rootBucket
              };
            }

            _context2.next = 3;
            return addLinksToHamtBucket(node.Links, context.lastBucket, context.rootBucket);

          case 3:
            _context2.next = 5;
            return context.rootBucket._findNewBucketAndPos(name);

          case 5:
            position = _context2.sent;
            prefix = toPrefix(position.pos);
            bucketPath = toBucketPath(position);

            if (bucketPath.length > context.hamtDepth) {
              context.lastBucket = bucketPath[context.hamtDepth];
              prefix = toPrefix(context.lastBucket._posAtParent);
            }

            link = node.Links.find(function (link) {
              if (link.Name == null) {
                return false;
              }

              var entryPrefix = link.Name.substring(0, 2);
              var entryName = link.Name.substring(2);

              if (entryPrefix !== prefix) {
                return false;
              }

              if (entryName && entryName !== name) {
                return false;
              }

              return true;
            });

            if (link) {
              _context2.next = 12;
              break;
            }

            return _context2.abrupt("return", null);

          case 12:
            if (!(link.Name != null && link.Name.substring(2) === name)) {
              _context2.next = 14;
              break;
            }

            return _context2.abrupt("return", link.Hash);

          case 14:
            context.hamtDepth++;
            _context2.next = 17;
            return blockstore.get(link.Hash, options);

          case 17:
            block = _context2.sent;
            node = dagPb.decode(block);
            return _context2.abrupt("return", findShardCid(node, name, blockstore, context, options));

          case 20:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function findShardCid(_x2, _x3, _x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

module.exports = findShardCid;